import React from 'react'
import '../../styles/mdx.scss'

export default function Grid2({ children }) {
  return (
    <div className="mdx">
        <div className="mdx__grid2">
            { children }
        </div>
    </div>
  )
}
